import React from "react";
import "../styles/podhu.css";

const Podhupani = () => {
  return (
    <div className="podhu-container">
      <div className="podhu-header">
        <h1 className="podhu-title">ஊழல் எதிர்ப்பு கூட்டம்</h1>
      </div>
      <div className="podhu-image-container">
        <img 
          src="https://makalukkaga.mpeoplesnet.com/podhu/podhu1.png" 
          alt="ஊழல் எதிர்ப்பு கூட்டம் படம்" 
          className="podhu-image"
        />
      </div>
      <div className="podhu-content">
        <p className="podhu-paragraph">
          <span className="podhu-specialText">
            அன்னா ஹசாரேவின் ஊழல் எதிர்ப்பு நடவடிக்கைகளுக்கு ஆதரவுக் குரல்
          </span>{" "}
          கொடுப்பதற்காகவும் வலுவான முதன்மையான லோக்பால் சட்டத்தை மத்திய அரசு
          நிறைவேற்றிடக்கோரியும், ஊழல் செய்து வெளிநாட்டு, உள்நாட்டு வங்கிகளில்
          குவித்து வைத்திருக்கும் பணத்தையும் ஊழல் மூலம் வாங்கியுள்ள
          சொத்துக்களையும் பரிமுதல் செய்து நாட்டுடைமையாக்க அரசை வலியுறுத்தியும்
          பேரவையின் சார்பில் ஊழல் எதிர்ப்புக் கூட்டம் 28.8.2011 ஆம் தேதி
          ஞாயிற்றுக்கிழமை ஈரோடு கொங்கு கலையரங்கில் நடைபெற்றது. இந்நிகழ்ச்சிக்கு
          மக்கள் சிந்தனைப் பேரவையின் தலைவர் த. ஸ்டாலின் குணசேகரன் தலைமையேற்றார்.
          மதுரை காந்தி மியூசியத் துணைத்தலைவரும் ஐந்து மாவட்டங்களின் ஆட்சித்
          தலைவர் பொறுப்பிலிருந்து ஓய்வு பெற்ற ஐஏஎஸ் அதிகாரியுமான தியாகி
          லட்சுமிகாந்தன்பாரதி ஐஏஎஸ்., அலுர்கள், காந்திகிராம கிராமியப் பல்கலைக்
          கழகத்தின் முன்னாள் துணைவேந்தர் பேராசிரியர் ந. மார்கண்டன் ஆகியோர்
          சிறப்புரை நிகழ்த்தினார்.
        </p>
        <p className="podhu-paragraph">
          <span className="podhu-specialText">
            இந்நிகழ்ச்சியில் ஊழல் எதிர்ப்பு உறுதிமொழி
          </span>{" "}
          வாசிக்கப்பட்டு அது பொதுமக்களால் உணர்ச்சி பொங்க ஏற்றுக்கொள்ளப்பட்டது.
          கலையரங்கமே நிரம்பி வழிந்த நிலையில் ஒரு எழுச்சிமிக்க மாநாடு போல
          இக்கூட்டம் நடைப்பெற்றது. ஊழல் எதிர்ப்பு என்பது பேரவையின் தலையாய
          குறிக்கோள்களில் ஒன்றாகும்.
        </p>
        <p className="podhu-paragraph">
          இதனை நெஞ்சில் நிறுத்தி இளைஞர்களின் உணர்விலேயே ஊழல் எதிர்ப்புச்
          சிந்தனையைப் ஆழப் பதிக்க வேண்டும் என்ற சீரிய சமுதாய நோக்கில் இக்கூட்டம்
          ஏற்பாடு செய்யப்பட்டிருந்தது குறிப்பிடத்தக்கதாகும்.
        </p>
      </div>
    </div>
  );
};

export default Podhupani;